<mat-dialog-actions class="justify-content-between">
    <h3>{{ 'LABEL.SELECT_SUGGESTED_INVESTIGATION' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <div *ngIf="isLoading" class="loader-overlay">
        <div class="loader-content">
            <mat-spinner diameter="50"></mat-spinner>
        </div>
    </div>

    <div *ngIf="!isLoading && categories.length > 0" class="investigation-container">
        <div class="category-pills">
            <button type="button" *ngFor="let category of categories; let index = index" class="category-pill"
                [class.active]="selectedCategoryIndex === index" (click)="selectCategory(index)">
                <span>{{ category.name }}</span>
                <span *ngIf="getSelectedCountForCategory(category) > 0" class="pill-count">
                    {{ getSelectedCountForCategory(category) }}
                </span>
            </button>
        </div>

        <div class="filter-box">
            <i-tabler name="search" class="icon-22 text-muted"></i-tabler>
            <input type="text" [value]="searchTerm" (input)="onSearchChange($any($event.target).value)"
                 [placeholder]="'LABEL.TYPE_TO_FILTER_FINDINGS' | translate" />
        </div>

        <ng-container *ngIf="getCurrentCategory() as category">
            <div *ngIf="hasVisibleItems(category); else noFilteredData" class="subcategory-list">
                <div *ngFor="let subcategory of getVisibleSubcategories(category)" class="subcategory-section">
                    <div class="subcategory-title">
                        <span>{{ subcategory.name }}</span>
                    </div>

                    <div class="checkbox-group">
                        <div class="checkbox-item" *ngFor="let item of getFilteredItems(subcategory)"
                            [class.selected]="isItemSelected(item)">
                            <mat-checkbox color="primary" [checked]="isItemSelected(item)"
                                (change)="onCheckboxChange(item, $event.checked)">
                            </mat-checkbox>
                            <span class="label-text">{{ item.description }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #noFilteredData>
                <div class="d-flex flex-column align-items-center justify-content-center no-items-message">
                    <i-tabler name="info-circle" class="icon-30 text-muted"></i-tabler>
                    <h4 class="f-w-600">{{ 'LABEL.NO_DATA' | translate }}</h4>
                </div>
            </ng-template>
        </ng-container>
    </div>

    <div *ngIf="!isLoading && categories.length === 0"
        class="d-flex flex-column align-items-center justify-content-center no-data-message">
        <i-tabler name="info-circle" class="icon-30 text-muted"></i-tabler>
        <h4 class="f-w-600">{{ 'LABEL.NO_DATA_AVAILABLE' | translate }}</h4>
    </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16 w-100">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCancel()">
                {{ 'BUTTON.BTN_CLOSE' | translate }}
            </button>
            <button mat-flat-button color="primary" class="m-l-4" (click)="onSave()">
                {{ 'BUTTON.BTN_SELECT' | translate }}
            </button>
        </div>
    </div>
</mat-dialog-actions>
